import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  input,
  signal,
} from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
})
export class TabsComponent implements AfterContentInit {
  initialIndex = input(0);
  activeIndex = signal(0);
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;

  ngAfterContentInit() {
    if (this.tabs.length > 0) {
      this.activeIndex.set(this.initialIndex());
    }
  }

  selectTab(index: number) {
    this.activeIndex.set(index);
  }
}
